import {selectSettings} from '../../../selectSettings'

export default {
  trial: {
    sections: [
      {
        id: 'mainDetails',
        type:'full',
        includes: [
          {
            label: 'Study Title',
            dataTag: 'title',
            required: true,
            typeEdit: 'textInput'
          },
          {
            label: 'Brief Description',
            required: true,
            dataTag: 'briefDescription',
            typeEdit: 'textareaInput',
            tooltip: 'Brief description is received from www.clinicaltrials.gov and is displayed in trial overview page of the public facing platform',
          },
          {
            label: 'Simplified Description',
            dataTag: 'customDescription',
            typeEdit: 'textareaInput',
            tooltip: 'Study Description - Patient Version is shown on the trial overview page of the public facing platform once the users select Simplified Descriptions.'
          },
          {
            label: 'Study Population - Eligibility Criteria',
            dataTag: 'eligibilityCriteria',
            typeEdit: 'textareaInput',
            tooltip: 'Eligibility Criteria is received from www.clinicaltrials.gov and is displayed in the trial overview page of the public facing platform'
          },
          {
            label: 'Simplified Eligibility',
            dataTag: 'studyPopulation',
            typeEdit: 'textareaInput',
            tooltip: 'Eligibility Criteria - Patient Version is shown on the trial overview page of the public facing platform once the users select Simplified Descriptions.'
          },
          {
            label: 'Simplified Primary Outcome',
            dataTag: 'whatsInvolved',
            typeEdit: 'textareaInput',
            tooltip: 'Simplified Primary Outcome is shown on the trial overview page of the public facing platform once the users select Simplified Descriptions.',
          },
          {
            label: 'Lead Sponsor',
            dataTag: 'leadSponsor',
            typeEdit: 'textInput'
          },
        ]
      },
      {
        id: 'studyTypes',
        type: 'sectionWrap',
        includes: [
          {
            label: 'Start Date',
            dataTag: 'startDate',
            typeEdit: 'calendar'
          },
          {
            label: 'End Date',
            dataTag: 'endDate',
            typeEdit: 'calendar'
          },
          {
            label: 'Study Type',
            dataTag: 'studyType',
            typeEdit: 'dropdown',
            dropdownOptions: {
              label: 'studyType',
              type: 'single',
              isClearable: false,
              options: selectSettings.studyType
            }
          },
          {
            label: 'Study Phase',
            dataTag: 'phaseToEdit',
            typeEdit: 'dropdown',
            dropdownOptions: {
              label: 'studyPhase',
              type: 'single',
              isClearable: false,
              options: selectSettings.studyPhase
            }
          }
        ]
      },
      {
        id:'conditions',
        type: 'full',
        includes:[
          {
            label: 'Select the conditions for this trial',
            required: true,
            dataTag: 'conditions',
            typeEdit: 'searchBar'
          }
        ]
      },
      {
        id: 'studyFilters',
        heading: 'Study Filters',
        type: 'sectionWrap',
        includes: [
          {
            label: 'Minimum Age (Months)',
            dataTag: 'minAge',
            typeEdit: 'numberInput'
          },
          {
            label: 'Maximum Age (Months)',
            dataTag: 'maxAge',
            typeEdit: 'numberInput'
          },
          {
            label: 'Gender',
            dataTag: 'genderToEdit',
            typeEdit: 'dropdown',
            dropdownOptions: {
              label: 'gender',
              type: 'single',
              isClearable: false,
              options: selectSettings.gender
            }
          },
          {
            label: 'Enrolling Healthy Volunteers?',
            dataTag: 'healthyVolunteers',
            typeEdit: 'dropdown',
            dropdownOptions: {
              label: 'healthyVolunteers',
              type: 'single',
              isClearable: false,
              options: selectSettings.healthy
            }
          },
        ]
      },
      {
        id: 'extraInfo',
        type: 'full',
        includes: [
          {
            label: 'ECOG Status',
            dataTag: 'pscore',
            typeEdit: 'dropdown',
            dropdownOptions: {
              label: 'pscore',
              type: 'multi',
              isClearable: false,
              options: selectSettings.ecogFormOptions
            }
          },
          {
            label: 'Enrolling Relapsed or Recurrent Disease?',
            dataTag: 'recurrentToEdit',
            typeEdit: 'dropdown',
            dropdownOptions: {
              label: 'recurrent',
              type: 'single',
              isClearable: false,
              options: selectSettings.prevTreatment
            }
          },
          {
            label: 'Eligible Mutations',
            dataTag: 'mutationsIN',
            typeEdit: 'dropdown',
            dropdownOptions: {
              label: 'recurrent',
              type: 'multi',
              isClearable: false,
              options: selectSettings.mutationOptions
            }
          },
          {
            label: 'Mutations: Not Eligible',
            dataTag: 'mutationsOUT',
            typeEdit: 'dropdown',
            dropdownOptions: {
              label: 'recurrent',
              type: 'multi',
              isClearable: false,
              options: selectSettings.mutationOptions
            }
          },
          {
            label: 'Extra Information',
            dataTag: 'extraInfo',
            tooltip: 'Any extra trial information that needs to be displayed on the overview page of the public facing platform',
            typeEdit: 'textareaInput'
          },
          {
            label: 'Study Notes',
            dataTag: 'studyNotes',
            tooltip: 'Notes regarding this trial. This will not show up on the patient facing platform',
            typeEdit: 'textareaInput'
          }
        ]
      },
      {
        id:'location',
        type: 'full',
        includes:[
          {
            label: 'Postion of trial relative to list',
            required: true,
            dataTag: 'position',
            typeEdit: 'position'
          }
        ]
      },
    ]
  }
}
